export interface CaptionCue { start: number; end: number; text: string }

function parseClock(value: string): number {
  const normalized = value.trim().replace(',', '.');
  const parts = normalized.split(':').map(Number);
  if (parts.some(Number.isNaN)) return 0;
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  return parts[0] * 60 + parts[1];
}

export function parseSrt(input: string): CaptionCue[] {
  return input.trim().split(/\r?\n\s*\r?\n/).flatMap((block) => {
    const lines = block.trim().split(/\r?\n/);
    const timingIndex = lines.findIndex((line) => line.includes('-->'));
    if (timingIndex < 0) return [];
    const [start, end] = lines[timingIndex].split('-->').map(parseClock);
    return end > start ? [{ start, end, text: lines.slice(timingIndex + 1).join('\n') }] : [];
  });
}

export function parseVtt(input: string): CaptionCue[] {
  return parseSrt(input.replace(/^WEBVTT[^\n]*\r?\n/, ''));
}

function clock(seconds: number, separator: ',' | '.'): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds / 60) % 60;
  const s = Math.floor(seconds) % 60;
  const ms = Math.round((seconds % 1) * 1000);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}${separator}${String(ms).padStart(3, '0')}`;
}

export function exportSrt(cues: CaptionCue[]): string {
  return cues.map((cue, index) => `${index + 1}\n${clock(cue.start, ',')} --> ${clock(cue.end, ',')}\n${cue.text}`).join('\n\n');
}

export function exportVtt(cues: CaptionCue[]): string {
  return `WEBVTT\n\n${cues.map((cue) => `${clock(cue.start, '.')} --> ${clock(cue.end, '.')}\n${cue.text}`).join('\n\n')}`;
}
